/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RefundDisabledReason {
  PROVIDER_UNSUPPORTED = 'provider_unsupported',
  NOT_THROUGH_SYSTEM = 'not_through_system',
  PAID_WITH_GIFT_CARD = 'paid_with_gift_card',
  BEFORE_REFUNDS = 'before_refunds',
  REFUND_IN_PROVIDER = 'refund_in_provider',
  PENDING = 'pending',
  FULLY_REFUNDED = 'fully_refunded',
  CONVERTED_TO_VOUCHER = 'converted_to_voucher',
}
